import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { queryStatusFor } from '../utils/contentMode.ts';
import UseEditorContentModeValueQuery, {
	type useEditorContentModeValueQuery$data,
	type useEditorContentModeValueQuery$variables,
} from '../hooks/__generated__/useEditorContentModeValueQuery.graphql.ts';

export const preloadContentMode = ({
	contentId,
	isDraft,
	useCache = false,
	isArchived,
}: {
	contentId: useEditorContentModeValueQuery$variables['contentId'];
	isDraft: useEditorContentModeValueQuery$variables['isDraft'];
	useCache: boolean;
	isArchived?: boolean;
}): Promise<{
	data: useEditorContentModeValueQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	const status = queryStatusFor(isDraft, isArchived);

	return query<useEditorContentModeValueQuery$data, useEditorContentModeValueQuery$variables>({
		query: UseEditorContentModeValueQuery,
		variables: {
			contentId,
			isDraft,
			status: [status],
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
